(function(){
'use strict';

angular.module('clientDashboardApp.admin.brand', [])
  .controller("BrandManagerCtrl", BrandManagerCtrl);

BrandManagerCtrl.$inject = ["$scope", "$uibModal", "$window"];
function BrandManagerCtrl($scope, $uibModal, $window){

    $scope.openLogoUploadModal = function(){

      let modalInstance = $uibModal.open({
        template: require('../../../common/imageUpload/imageUploadModal.html'),
        size: 'md',
        controller: "ImageUploadModalCtrl",
        resolve: {
          imageType : () => "Logo",
          accountId : () => null,
          preventSave : () => false,
          imageUploadEndpoint: () => "/image/upload",
          afterSaveCallback: () => (uploadedImageUrl) => {},
        }
      });

      modalInstance.result.then((resp) => {
        console.log(resp)
          if(!resp){
            $window.location.reload();
          }
      })

    }

  };
})();
